import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";

import localAxios from "axios";

class AllureDockerInfoDialog extends Component {
  state = {
    version: null,
  };

  getConfig = () => {
    const axios = localAxios.create();
    axios
      .get(`${process.env.PUBLIC_URL}/config.json`)
      .then((response) => {
        this.setState({ version: response.data.version });
      })
      .catch((error) => {
        this.setState({ version: 'NOT_FOUND' });
      });
  };

  handleCloseDialog = () => {
    this.props.handleCloseDialog();
  };

  componentDidUpdate() {
    if (!this.state.version) {
      this.getConfig();
    }
  }

  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.handleCloseDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">INFO</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography
              component="span"
              variant="h6"
              color="textSecondary"
              align="left"
            >
              Allure UI Version
            </Typography>
            <Typography
              variant="subtitle2"
              color="secondary"
              align="center"
            >
              {this.state.version}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCloseDialog} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default AllureDockerInfoDialog;
